import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';
import { Screen } from '@/components/ui/Screen';

export interface RecoveryScreenProps {
  /** Emoji glyph for the failure — the one thing that tells the two screens apart at a glance. */
  icon: string;
  title: string;
  body: string;
  /** Re-run whatever failed. */
  onRetry: () => void;
  /** Abandon the session and start over at sign-in. */
  onSignOut: () => void;
}

/**
 * The shape the fail-closed screens share: something the app was about to read could not be
 * vouched for, so we render this instead, offering the only two ways out. See
 * `SessionErrorScreen` and `StaleCacheScreen` for what each one stands in for.
 */
export function RecoveryScreen({
  icon,
  title,
  body,
  onRetry,
  onSignOut,
}: RecoveryScreenProps) {
  return (
    <Screen>
      <EmptyState
        className="flex-1 justify-center"
        icon={icon}
        title={title}
        body={body}
        action={{ label: 'Try again', onPress: onRetry, variant: 'primary' }}
      />
      <Button
        className="mb-6 self-center"
        variant="ghost"
        label="Sign out"
        onPress={onSignOut}
      />
    </Screen>
  );
}
